export default class OutlineList {
    fieldsIds = []
    items = []

    add(item) {
        this.items.push(item)
    }

    getItemById(id) {
      return this.items.find((item) => item.id === id)
    }

    getItemByFieldId(fieldId) {
      return this.items.find((item) => item.inputData.fieldId === fieldId);
    }

    update(id, data) {
      const item = this.getItemById(id)
      if (!item) return

      item.inputData.setData(data)
    }

    getInputDataJson(objectId) {
      const item = this.items.find(item => item.id === objectId);

      return item.inputData._toString();
    }

    getAllInputDataJson() {
      return this.fieldsIds.map(id => {
        const item = this.items.find(item => item.templateField.getId() === id);

        return item ? item.inputData._toString() : JSON.stringify([]);
      })
    }

    removeByFieldId(id, canvas) {
      this.items = this.items.filter(item => {
        if (item.templateField.getId() === id) {
          item.removeObjects(canvas)
        } else {
          return item 
        }
      })
    }

    removeAll(canvas) {
      this.fieldsIds.forEach(fieldId => {
        this.removeByFieldId(fieldId, canvas)
      })
    }

    render(canvas, isRenderAll = true) {
        const promise = []
        this.items.forEach(async item => {
          if (item.object && !isRenderAll) return
  
          item.removeObjects(canvas)
          
          promise.push(item.render())
        })
  
        return Promise.all(promise).then(res => {
          res.forEach(item => {
            canvas.add(item)
          })
        })
    }
}